/* The quote-price script. Built by tools/build-assets.mjs from the review set; edit the review set, not this file. */
/* XGO web: the live packages page script, 2026-09-17 capture. Two edits only: short ids, and figures of 1,000 and over carry a separator. */

(function () {
  var root = document.documentElement;
  if (!root || root.dataset.xgoQuotePrice) return;
  root.dataset.xgoQuotePrice = '1';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO  = 'IntersectionObserver' in window;
  var SENS   = { yes: 'Yes', opt: 'Optional', na: 'Not fitted' };
  /* ---------- the quote isn't the price ----------
     Heights come from CSS custom properties on the graphic itself,
     so it rescales at each breakpoint without repeating any of
     those numbers here. The void is sized from the real number of
     extras, which keeps both columns exactly level. */
  var cmp = root.querySelector('[data-cmp]');
  if (cmp) {
    var cs = function (n) { return parseFloat(getComputedStyle(cmp).getPropertyValue(n)) || 0; };
    /* Heights are MEASURED, not assumed.
       The old version multiplied a fixed --blk-h by the number of
       extras. That only holds while every label fits on one line -
       the moment a label wraps, the real row is taller than --blk-h,
       the arithmetic under-counts and the void no longer matches the
       stack it is supposed to mirror. Measuring each row means the two
       columns finish level whatever the labels say, in any language,
       at any width. --blk-h and --base-h survive as MINIMUMS, so short
       labels still give the uniform bars the chart is drawn around. */
    var runCmp = function () {
      var minBase = cs('--base-h'), minBlk = cs('--blk-h'), gap = cs('--blk-gap');
      var rows = [].slice.call(cmp.querySelectorAll('[data-h]'));
      cmp.classList.add('is-measuring');
      var nat = rows.map(function (el) {
        if (el.dataset.h === 'void') return 0;
        var prev = el.style.height;
        el.style.height = 'auto';
        var h = el.getBoundingClientRect().height;
        el.style.height = prev;
        return Math.max(h, el.dataset.h === 'base' ? minBase : minBlk);
      });
      /* The left column is n blocks with n gaps above the base bar. The
         right column is ONE void with ONE gap above its base bar, so the
         void spans n blocks plus only (n-1) gaps - the gap above it is
         already there. Counting n gaps is what used to leave the XGO
         caption sitting a few pixels lower than its neighbour. */
      var blks = 0, nBlk = 0;
      rows.forEach(function (el, i) {
        if (el.dataset.h === 'blk') { blks += nat[i]; nBlk++; }
      });
      var voidH = nBlk > 0 ? blks + (gap * (nBlk - 1)) : 0;
      void cmp.offsetHeight;                       /* land the restores before re-enabling transitions */
      cmp.classList.remove('is-measuring');
      cmp.classList.add('is-run');
      rows.forEach(function (el, i) {
        el.style.height = (el.dataset.h === 'void' ? voidH : nat[i]) + 'px';
      });
    };
    if (reduce || !hasIO) { runCmp(); }
    else {
      var cio = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        runCmp(); cio.disconnect();
      }, { threshold: 0.3 });
      cio.observe(cmp);
    }
    /* Re-measure on resize, on orientation change and once webfonts
       land - a fallback face wraps differently from the real one and
       a stack measured against Arial is wrong the moment Archivo
       arrives. */
    var rt;
    var remeasure = function () {
      if (!cmp.classList.contains('is-run')) return;
      window.clearTimeout(rt);
      rt = window.setTimeout(runCmp, 150);
    };
    window.addEventListener('resize', remeasure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);
    /* The figures by platform (the price tiers): the vehicle picked shows its own, a page with no pick the standard ones. Each
       tier sits on the graphic as data-tier-<tier>, "our price|the typical quote's base|its total"; a pick swaps the four figures,
       measures the columns again and tells a screen reader what changed (data-cmp-note, aria-live) */
    var tierNote = cmp.parentNode.querySelector('[data-cmp-note]');
    var low = function (t) { return t.replace(/^From /, 'from '); };
    var setTier = function (tier, name) {
      var row = cmp.getAttribute('data-tier-' + tier) || cmp.getAttribute('data-tier-standard');
      if (!row) return;
      var f = row.split('|');
      var put = function (sel, t) { var el = cmp.querySelector(sel); if (el && t) el.textContent = t; };
      put('.ti-col--xgo .ti-base', f[0]); put('.ti-col--xgo .ti-col__cap em', f[0]);
      put('.ti-col--other .ti-base', f[1]); put('.ti-col--other .ti-col__cap em', f[2]);
      cmp.setAttribute('data-price-tier', tier);   /* not data-tier: the package buttons' script takes every [data-tier] */
      if (tierNote && name) tierNote.textContent = name + ': the XGO price ' + low(f[0]) + ', with nothing to add; a typical quote ' + low(f[1]) + ', coming to ' + f[2] + '.';
      if (cmp.classList.contains('is-run')) runCmp();
    };
    root.addEventListener('ti-tier', function (e) { setTier(e.detail.tier, e.detail.name); });
    var pickedVeh = root.querySelector('[data-veh].is-on');
    if (pickedVeh) setTier(pickedVeh.getAttribute('data-price-tier') || 'standard');
  }
  /* ---------- tier button carries the choice into the form ---------- */
  var pkg = root.querySelector('[data-pkg]');
  if (pkg) root.querySelectorAll('[data-tier]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      pkg.value = btn.dataset.tier;
      pkg.classList.add('is-set');
      window.setTimeout(function () { pkg.classList.remove('is-set'); }, 1600);
    });
  });
})();
